
<div class="b-validation-messages is-animated" *ngIf="getMessage()">
  <div class="b-validation-message g-textoverflow" [title]="getMessage()">
    <div class="b-validation-message-text">{{ getMessage() }}</div>
  </div>
</div>